import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DashboardKpiTimeRange } from '../enums/dashboard-kpi-time-range.enum';
import { DashboardJobActivitiesResponse } from '../interfaces/dashboard-job-activity';
import { DashboardKpis } from '../interfaces/dashboard-kpis.interface';

@Injectable({
  providedIn: 'root',
})
export class DashboardAdapter {
  private readonly http = inject(HttpClient);

  getKpis(timeRange: DashboardKpiTimeRange): Observable<DashboardKpis> {
    const params = new HttpParams().set('timeRange', timeRange);
    return this.http.get<DashboardKpis>(
      `${environment.apiBaseUrl}/company/user/dashboard/kpis`,
      { params }
    );
  }

  getJobActivities(): Observable<DashboardJobActivitiesResponse> {
    return this.http.get<DashboardJobActivitiesResponse>(
      `${environment.apiBaseUrl}/company/user/dashboard/job-activities`
    );
  }
}
